import React, { FC } from 'react';
import styled from '@emotion/styled';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';

const Note = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.28);
`;

interface Props {
  children: React.ReactNode;
}

/** Tinted red box for an error or refusal message, made for dark surfaces such as modals. */
const ErrorNote: FC<Props> = ({ children }) => (
  <Note role="alert">
    <Paragraph level={3} fontWeight={600} color="var(--colorUIRed)">
      {children}
    </Paragraph>
  </Note>
);

export default ErrorNote;
